const getTheme = state => state.view.theme || 'icom';

export default getTheme;
